<app-fleet-page-header
  (clearFilter)="listModel.resetFilter()"
  (clearSearch)="listModel.setSearch('')"
  (dateRangeChanged)="listModel.setDateRange($event, true)"
  (export)="listModel.exportReport($event)"
  (filterChanged)="listModel.setFilter($event, true)"
  (searchChanged)="listModel.setSearch($event)"
  (rememberFiltersChanged)="listModel.setRememberFilters($event)"
  (sortChanged)="listModel.setOrder($event, true)"
  [dateRange]="listModel.state.dateRange$ | async"
  [defaultSortOrder]="listModel.state.defaultSortOrder$ | async"
  [filterOptions]="listModel.state.filterOptions$ | async"
  [filterValue]="listModel.state.filter$ | async"
  [rememberFilterValues]="listModel.state.rememberFilters$ | async"
  [search]="listModel.state.search$ | async"
  [showActionsSpacer]="true"
  [showReturnButton]="true"
  [showOptionsSeparator]="true"
  [showSearch]="true"
  [defaultReturnRoute]="listModel.defaultReturnRoute"
  [templates]="{ actionButtons, rightControls }"
  [sortOrder]="listModel.state.gridSortOrder$ | async"
  [titleText]="listModel.title"
  [columns]="listModel.state.columns$ | async"
  [headerTextSize]="24"
></app-fleet-page-header>

<app-role-management-grid></app-role-management-grid>

<ng-template #rightControls></ng-template>

<ng-template #actionButtons>
  <p-button
    class="h--40 p--16 text-14 fw-600"
    [appCheckAccess]="[TYPES.Resource.Role, TYPES.Action.Create]"
    (click)="editModel.add()"
  >
    <app-icon-plus
      [height]="20"
      [width]="20"
      [color]="'var(--icon-color)'"
      class="icon"
    ></app-icon-plus>
    {{ 'roles.buttons.add' | translate }}
  </p-button>
</ng-template>

<app-edit-role-dialog (duplicateClicked)="duplicateAndOpen($event)"></app-edit-role-dialog>
